import React from "react"

export interface Notif {
  type: string
  header: string
  id: string
  message: string
}

export default function Notifications({
  notifs,
  deleteNotif
}: {
  notifs?: Notif[] | null
  deleteNotif?: any
}): React.JSX.Element {
  if (notifs == null || notifs.length == 0) return <></>

  return (
    <div className="fixed z-50 w-full max-w-[600px] left-1/2 -translate-x-1/2 h-fit">
      {notifs
        ?.filter((notif) => {
          return notif.type == "banner"
        })
        .map((info) => (
          <div
            key={info.id}
            className="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
            role="alert"
          >
            <div className="flex">
              <div className="py-1">
                <svg
                  className="fill-current h-6 w-6 text-teal-500 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                </svg>
              </div>
              <div className="">
                <div className="flex flex-col items-center ">
                  <div>
                    <p className="font-bold">{info.header}</p>
                    <p className="text-sm">{info.message}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      {notifs
        ?.filter((notif) => {
          return notif.type == "success"
        })
        .map((info) => (
          <div
            key={info.id}
            className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mt-4 flex flex-col"
            role="alert"
          >
            <strong className="font-bold">{info.header}</strong>
            <span className="block sm:inline">{info.message}</span>
            <span
              className="absolute top-0 bottom-0 right-0 px-4 py-3"
              onClick={() => {
                deleteNotif(info.id)
              }}
            >
              <svg
                className="fill-current h-6 w-6 text-green-500"
                role="button"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
              </svg>
            </span>
          </div>
        ))}
      {notifs
        ?.filter((notif) => {
          return notif.type == "error"
        })
        .map((error) => (
          <div
            key={error.id}
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-4 flex flex-col"
            role="alert"
          >
            <strong className="font-bold">{error.header} </strong>
            <span className="block sm:inline">{error.message}</span>
            <span
              className="absolute top-0 bottom-0 right-0 px-4 py-3"
              onClick={() => {
                deleteNotif(error.id)
              }}
            >
              <svg
                className="fill-current h-6 w-6 text-red-500"
                role="button"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
              </svg>
            </span>
          </div>
        ))}
      {notifs
        ?.filter((notif) => {
          return notif.type == "warning"
        })
        .map((error) => (
          <div
            key={error.id}
            className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative mt-4 flex flex-col"
            role="alert"
          >
            <strong className="font-bold">{error.header} </strong>
            <div className="block sm:inline">{error.message}</div>
            <span
              className="absolute top-0 bottom-0 right-0 px-4 py-3"
              onClick={() => {
                deleteNotif(error.id)
              }}
            >
              <svg
                className="fill-current h-6 w-6 text-yellow-500"
                role="button"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
              </svg>
            </span>
          </div>
        ))}
    </div>
  )
}
